import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FirebaseStorageService {
  constructor(private httpClient: HttpClient) {}

  async uploadFile(file: File, eventId: string | null): Promise<string | null> {
    try {
      if (!eventId) {
        console.error('Event ID is required for logo upload');
        return null;
      }

      // Convert file to base64
      const base64Data = await this.fileToBase64(file);
      
      const uploadData = {
        fileData: base64Data,
        fileName: file.name,
        fileType: file.type
      };

      const url = `${environment.spaceClaimBaseURL}/${eventId}/logo`;
      const headers = new HttpHeaders({
        'Content-Type': 'application/json'
      });

      const response = await this.httpClient.post<{logoUrl: string, message: string}>(
        url,
        uploadData,
        { headers, observe: 'response' }
      ).toPromise();

      if (response?.body?.logoUrl) {
        return response.body.logoUrl;
      } else {
        console.error('No logo URL in response:', response);
        return null;
      }
    } catch (error) {
      console.error('Error uploading file:', error);
      return null;
    }
  }

  async uploadAgenda(file: File, eventId: string | null): Promise<string | null> {
    try {
      if (!eventId) {
        console.error('Event ID is required for agenda upload');
        return null;
      }

      const base64Data = await this.fileToBase64(file);
      const uploadData = {
        fileData: base64Data,
        fileName: file.name,
        fileType: file.type,
      };

      const url = `${environment.spaceClaimBaseURL}/${eventId}/agenda`;
      const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

      const response = await this.httpClient.post<{agendaUrl: string, message: string}>(
        url,
        uploadData,
        { headers, observe: 'response' }
      ).toPromise();

      if (response?.body?.agendaUrl) {
        return response.body.agendaUrl;
      } else {
        console.error('No agenda URL in response:', response);
        return null;
      }
    } catch (error) {
      console.error('Error uploading agenda:', error);
      return null;
    }
  }

  async deleteFile(path: string): Promise<boolean> {
    // Server-side deletion not implemented
    return true;
  }

  private fileToBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const result = reader.result as string;
        const base64 = result.split(',')[1];
        resolve(base64);
      };
      reader.onerror = error => reject(error);
    });
  }

  getEventLogoImagePath(eventId: string | null): string {
    if (eventId == null) {
      return `events/logosDir/${Date.now()}`;
    }
    return `events/${eventId}/logo`;
  }
} 